export default __webpack_public_path__ + "static/media/vegan_porridge.e249c18f.jpg";